<div class="clinical-trial-selector-container">
  <div class="clinical-trials-container">
    <div *ngIf="hasClinicalTrial()" class="clinical-trial-link icon__LinkExternal pointer" (click)="openClinicalTrialUrl()"
         [dlsTooltip]="'Click here to view the selected clinical trial'"
         [tooltipPosition]="'Left'"
         [tooltipShowDelay]="1"
         [tooltipHideDelay]="200"></div>
    <div *ngIf="!hasClinicalTrial()" class="clinical-trial-link icon__LinkExternal not-active-icon"
         [dlsTooltip]="'Click here to view the selected clinical trial'"
         [tooltipPosition]="'Left'"
         [tooltipShowDelay]="1"
         [tooltipHideDelay]="200"></div>

        <p-panel [toggleable]="false" #panel class="clinical-trial-panel">
          <gen-dynamic-form
            class="dynamic-form-table"
            (formChange)="updateItemValue($event)"
            [formData]="data"
            [formName]="payload.config.formName"
            [disabled]="payload.readOnlyMode"
            [formVertical]="true"
            [additionalSearchValues]="revisedEntitiesRevisionsData"
            [emitFormChangeEvenIfInvalid]="true">
          </gen-dynamic-form>
        </p-panel>
  </div>

  <section class="clinical-trial-nodes-container" id="nodesSelectionContainer">
    <div class="nodes-container-header">
      <span>Add Node Placement</span>
    </div>

    <div class="nodes-selection-container">
      <gen-dynamic-form
        [formData]="data"
        [formName]="'PATHWAYBPMN-CLINICAL-TRIAL-NODES-SELECTION'"
        [formVertical]="true"
        [updateOnBlur]="true"
        [editMode]="true"
        [disabled]="payload.readOnlyMode || !hasClinicalTrial()"
        (formChange)="updateNodes($event.form)">
      </gen-dynamic-form>
    </div>

    <div class="nodes-selection-container-message"
         *ngIf="!hasClinicalTrial() || !data.nodes || data.nodes.length === 0">
      <span>Select ‘Clinical Trial’ and then a node from the dropdown or pathway tree, proceed by clicking on the + icon to add a clinical trial to the selected node.</span>
    </div>
  </section>
</div>

